<style scoped lang="scss">
.strengths {
  display: flex;
  margin-top: 30px;
  li {
    flex: 1;
    text-align: center;
    border-right: 1px solid #eee;
    padding: 0 40px;
    &:last-child {
      border: 0;
    }
    h4 {
      font-size: 18px;
      margin-bottom: 10px;
      color: #014492;
    }
  }
}
.cons {
  display: none;
}
.service_chan {
  margin-bottom: 20px;
  display: flex;
  overflow: auto;
  justify-content: space-between;
  li {
    //width: 190px;
    //height: 188px;
    //margin-right:100px;
    background: url("../../assets/img/产品及服务/fuwu.jpg") no-repeat !important;
    background-size: auto !important;
    .img {
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    p {
      font-size: 16px;
      color: #4e4e4e;
      margin-bottom: 10px;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .liaojie {
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      color: #959595;
      cursor: pointer;
    }
  }
  li:hover {
    background: url("../../assets/img/产品及服务/fuwu1.jpg") no-repeat !important;
    background-size: auto !important;
    p {
      color: #fff;
    }
    .liaojie {
      color: #fff;
    }
  }
  li:last-child {
    margin-right: 0;
  }
}
.download {
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #e4e6ea;
  li {
    width: 50%;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e4e6ea;
    border-right: 1px solid #e4e6ea;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1) {
      border-top: 1px solid #e4e6ea;
    }
    &:nth-of-type(2) {
      border-top: 1px solid #e4e6ea;
    }
    &:hover {
      color: #014492;
    }
  }
  .btn-primary {
    font-size: 14px;
    span {
      margin-right: 7px;
    }
  }
  .mr41 {
    display: block;
  }
  .mr42 {
    display: none;
  }
}
.table {
  tr {
    td:first-child {
      background: #f6fafd;
    }
  }
}
.c-title small {
  margin-top: 10px;
}
.service {
  padding-bottom: 50px;
  background: url("../../assets/img/产品及服务/合成基因组学产品及服务/bg.png")
    no-repeat;
  background-size: 100% 100%;
}
.required {
  background: none !important;
  margin-left: 0 !important;
}
.desc {
  font-size: 16px;
  a {
    color: rgb(1, 68, 146);
    font-weight: bold;
  }
}
.effect-lists {
  //display: block!important;
  overflow: auto;
}
.effect-lists li {
  margin-right: 62px;
  float: left;
}
.effect-lists1 li {
  margin-right: 40px !important;
  float: left;
}
.effect-lists li:last-child {
  margin-right: 0;
}
.youshi {
  padding-bottom: 50px;
  background: #f6fafd;
}
.xing_1 {
  display: flex;
  overflow: auto;
  justify-content: space-between;
  flex-wrap: wrap;
  li {
    height: 312px;
    width: 380px;
    //margin-right: 30px;
    .img {
      width: 123px;
      padding-top: 43px;
      padding-bottom: 45px;
      margin-left: auto;
      margin-right: auto;
    }
    p {
      font-size: 20px;
      color: #fff;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
  }
  li:last-child {
    margin-right: 0;
  }
  .xingcheng1 {
    overflow: auto;
    background: url("../../assets/img/gene.jpg") no-repeat;
    background-size: auto;
  }
  .xingcheng2 {
    overflow: auto;
    background: url("../../assets/img/biology.jpg") no-repeat;
    background-size: auto;
  }
  .xingcheng3 {
    overflow: auto;
    background: url("../../assets/img/life.jpg") no-repeat;
    background-size: auto;
  }
  //鼠标移入后
  .xingcheng1:hover {
    overflow: auto;
    cursor: pointer;
    background: url("../../assets/img/gene1.jpg") no-repeat;
    background-size: auto;
  }
  .xingcheng2:hover {
    overflow: auto;
    cursor: pointer;
    background: url("../../assets/img/biology1.jpg") no-repeat;
    background-size: auto;
  }
  .xingcheng3:hover {
    overflow: auto;
    cursor: pointer;
    background: url("../../assets/img/life1.jpg") no-repeat;
    background-size: auto;
  }
}
@media screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width: 400px) {
  .container100 {
    margin-bottom: 20px !important;
  }
  .cons .xing_1 {
    display: block !important;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }
  .cons .xing_1 li {
    margin-bottom: 10px;
    width: 320px !important;
    margin-right: 0 !important;
    height: 200px !important;
  }
  .cons .xing_1 li .img {
    width: 70px !important;
  }
  .cons .xing_1 li:last-child {
    margin-bottom: 0;
  }
  .cons .xing_1 li .img {
    padding-top: 35px !important;
    padding-bottom: 35px !important;
  }
  .cons .xing_1 .xingcheng1:hover {
    background: url("../../assets/img/life.jpg") no-repeat !important;
  }
  .cons .xing_1 .xingcheng2:hover {
    background: url("../../assets/img/biology.jpg") no-repeat !important;
  }
  .cons .xing_1 .xingcheng3:hover {
    background: url("../../assets/img/gene.jpg") no-repeat !important;
  }
  .cons .service_chan li {
    width: 190px;
    height: 188px;
    //margin-right:60px;
    //background: url("../../assets/img/产品及服务/fuwu.jpg") no-repeat !important;
    //background-size: auto !important;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div
      class="banner"
      v-if="
        !$route.meta.invisible && !$route.meta.invisibles && !$route.meta.show
      "
    >
      <!-- alt: 擎科生物-生命科学研究设备及原料 -->
      <div class="con">
        <img
          src="@/assets/img/设备及原料/生命科学研究设备及原料/banner.png"
          class="img-fluid"
          alt="基因合成原料与设备"
        />
      </div>
      <div class="cons">
        <img
          src="@/assets/img/研究领域banner/生命科学研究设备.jpg"
          class="img-fluid"
          alt="基因合成原料与设备"
        />
      </div>
      <div class="info"></div>
    </div>
    <section
      v-if="
        !$route.meta.invisible && !$route.meta.invisibles && !$route.meta.show
      "
    >
      <div
        class="breads container"
        style="
          overflow: auto;
          line-height: 48px;
          padding-left: 10px;
          margin-bottom: 20px;
          margin-top: 20px;
        "
      >
        <bread></bread>
      </div>
      <div class="container container100" style="margin-bottom: 100px">
        <p class="desc">
          擎科生物围绕合成科学，运用智能化、工厂化思维，集合成原料（生物试剂和化学试剂）、合成设备、合成工艺于一体，搭建智能化合成产线，在数字化管理系统（TSINGKE HELIXTECH）的赋能下，形成了自主全产业链生产平台。为客户提供
          <a href="/tec/compose">寡核苷酸合成</a>、
          <a href="/equipment/Modified_synthesis">寡核苷酸修饰</a>、
          <a href="/tec/gen_compose">基因合成</a>、
          <a href="/products/Gene">基因检测</a>、
          <a href="/equipment/Chemical_Reagents">化学试剂</a>、
          <a href="/equipment/Molecular_reagent">生物试剂</a>、
          <a href="/equipment/Instruments_equipment">仪器设备</a>、
          <a href="/products/recombinant-cells-protein-expression">抗体蛋白</a>、
          基因调控等多种服务和产品。
        </p>
        <p class="desc">
          修饰合成方面：梓熙生物是擎科生物的全资子公司，专注于寡核苷酸合成领域，积累了丰富的Oligo合成研发经验。依托先进的工艺和完备的供应链网络，公司在北京和苏州分别建立了符合GMP标准的Oligo生产实验室，并获得了ISO 13485认证。梓熙生物提供多种修饰类型的DNA/RNA合成服务，包括Custom DNA Oligos和Custom RNA Oligos等，广泛应用于基础科研、生物农业、生物医学研究、体外诊断和基因检测等领域。        
        </p>
        <p class="desc">
          合成设备方面：擎科生物凭借雄厚的研发实力和核酸全产业链优势，开发出一系列具备差异化功能的产品，应用于不同领域。根据合成需求，擎科生物研发了多种单链核酸合成仪，包括高通量和高载量的高质量合成仪，以及配套的溶解仪、氨解仪、纯化仪和分装仪等设备。这些产品广泛应用于科研、医疗和工业生产，为客户提供全面的核酸合成解决方案。
        </p>
        <p class="desc">
          化学试剂方面：迪纳兴科作为擎科生物的全资子公司，在DNA/RNA合成试剂、实验耗材及修饰原料的生产和销售方面具有丰富的经验。公司积累了多年先进的生产工艺，并在河北建立了超3万平方米的生产基地。迪纳兴科已获得ISO9001质量管理体系证书及环境管理体系认证，产品广泛应用于基础科研、生物医药和核酸药物等领域。
        </p>
        <p class="desc">
          生物试剂方面：达领生物是擎科生物创立的新兴品牌，专注研发及生产生物试剂、IVD酶原料与仪器设备。达领生物依托湖北擎科生物科技有限公司，拥有集研发中心、十万级GMP自动化生产车间、质量检测及多温区仓储中心于一体的综合基地，总面积超4500平方米，现已建立蛋白质定向进化与改造平台、发酵与纯化平台、分子互作平台等多个技术平台。达领生物致力于突破关键技术障碍，减少对进口的依赖，推动国产化产品的进口替代。
        </p>
        <div class="con">
          <ul class="service_chan effect-lists" style="margin-top: 30px">
            <li
              v-for="(item, index) in gene2"
              :key="index"
              class="pointer"
              :class="{ active: currentType === index }"
              @mouseover="currentType = index"
              @mouseout="currentType = -1"
              @click="$router.push(item.ref)"
            >
              <img
                v-if="item.img[0] === '/'"
                :src="`/static/img${item.img}${
                  currentType === index ? '' : '_active'
                }.png`"
              />
              <img
                v-else
                :src="`/static/img/ke_${item.img}${
                  currentType === index ? '' : '_active'
                }.png`"
              />
              <p style="margin-top: 10px">{{ item.name }}</p>
              <div class="liaojie" @click="$router.push(item.ref)">
                了解更多>
              </div>
            </li>
          </ul>
        </div>
        <div class="cons">
          <ul class="service_chan" style="margin-top: 30px">
            <li
              v-for="(item, index) in gene2"
              :key="index"
              class="pointer"
              @click="$router.push(item.ref)"
            >
              <div class="gene_img2">
                <img
                  v-if="item.img[0] === '/'"
                  :src="`/static/img${item.img}${
                    currentType === index ? '' : '_active'
                  }.png`"
                />
                <img
                  v-else
                  :src="`/static/img/ke_${item.img}${
                    currentType === index ? '' : '_active'
                  }.png`"
                />
              </div>
              <p style="margin-top: 10px">{{ item.name }}</p>
              <div class="liaojie" @click="$router.push(item.ref)">
                了解更多>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="youshi">
        <div class="container">
          <div class="c-title">
            擎科生物优势<small>Advantages of Tsingke</small>
          </div>
          <img
            src="@/assets/img/设备及原料/生命科学研究设备及原料/ys.png"
            class="img-fluid con"
            alt="科生物-生命科学研究设备及原料优势-坚持自主创新、原料严格把关、产能持续提升、产品品质升级、生产智能自动、自主物流配送"
            style="margin-bottom: 10px"
          />
          <img
            src="@/assets/img/设备及原料/生命科学研究设备及原料/ys_2.png"
            class="img-fluid cons"
            alt="科生物-生命科学研究设备及原料优势-坚持自主创新、原料严格把关、产能持续提升、产品品质升级、生产智能自动、自主物流配送"
            style="margin-bottom: 10px"
          />
          <p class="desc">
            1.国内外领先的核酸合成原材料服务商，生产、销售超200种核酸合成用化学原材料，自产自用，为全球多家DNA合成企业提供核酸合成原材料。
          </p>
          <p class="desc">
            2.在2014年成功研制出首台单链核酸合成仪-192，并在随后的几年开发出系列可应用于不同领域具备差异化功能的产品，如不同规格合成仪、纯化仪、溶解仪、分装仪等仪器。
          </p>
          <p class="desc">
            3.依托于本公司的化学合成原材料部门提供的修饰 CPG
            单体，生产百种高质量修饰引物和修饰探针；通过先进的质谱（MS）检测和色谱（HPLC）检测，保证每一条修饰探针和RNA序列质量。
          </p>
          <!-- <p class="desc">4.拥有8大产品线，约60小类自主品牌分子生物学试剂产品，基本涵盖分子生物学试验所用的各种试剂，为科研实验赋能。“极速PCR MIX“等多种产品均遵守极速、高效的理念，为客户提供高效的产品和服务。</p> -->
          <p class="desc">
            4.拥有9大产品线，近百小类自主品牌分子生物学试剂产品，涵盖分子生物学试验所用的各种试剂，为客户提供高效的产品和服务，为科研实验赋能。
          </p>
        </div>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{ item.name }}
            <el-button
              type="primary"
              class="mr41"
              icon="el-icon-download"
              v-if="item.resourceFile.fileType === 'PICTURE'"
              @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)"
              >下载</el-button
            >
            <el-button
              type="primary"
              class="mr41"
              icon="el-icon-download"
              @click="downFile(item)"
              v-else
              >下载</el-button
            >
            <el-button
              type="primary"
              class="mr42"
              size="mini"
              icon="el-icon-download"
              v-if="item.resourceFile.fileType === 'PICTURE'"
              @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)"
              >下载</el-button
            >
            <el-button
              type="primary"
              class="mr42"
              size="mini"
              icon="el-icon-download"
              @click="downFile(item)"
              v-else
              >下载</el-button
            >
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">
          相关研究领域<small>Related Research Fields</small>
        </div>
        <div class="con">
          <ul class="xing_1">
            <li class="xingcheng1" @click="$router.push('/products/Products1')">
              <div class="img">
                <img
                  src="@/assets/img/gene.png"
                  width="100%"
                  alt="擎科生物-合成基因组学产品及服务
"
                />
              </div>
              <p>合成基因组学产品及服务</p>
            </li>
            <li
              class="xingcheng2"
              @click="$router.push('/Biological_manufacturing/Biological')"
            >
              <div class="img">
                <img
                  src="@/assets/img/biology.png"
                  width="100%"
                  alt="擎科生物-生命科学研究设备及原料
"
                />
              </div>
              <p>生物制造CXO</p>
            </li>
            <li
              class="xingcheng3"
              @click="$router.push('/equipment/life_sciences')"
            >
              <div class="img">
                <img
                  src="@/assets/img/life.png"
                  width="100%"
                  alt="擎科生物-生物制造CXO"
                />
              </div>
              <p>生命科学研究设备及原料</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px">
          <ul class="xing_1">
            <li class="xingcheng1" @click="$router.push('/products/Products1')">
              <div class="img">
                <img
                  src="@/assets/img/gene.png"
                  width="100%"
                  alt="擎科生物-合成基因组学产品及服务"
                />
              </div>
              <p>合成基因组学产品及服务</p>
            </li>
            <li
              class="xingcheng2"
              @click="$router.push('/Biological_manufacturing/Biological')"
            >
              <div class="img">
                <img
                  src="@/assets/img/biology.png"
                  width="100%"
                  alt="擎科生物-生命科学研究设备及原料
"
                />
              </div>
              <p>生物制造CXO</p>
            </li>
            <li
              class="xingcheng3"
              @click="$router.push('/equipment/life_sciences')"
            >
              <div class="img">
                <img
                  src="@/assets/img/life.png"
                  width="100%"
                  alt="擎科生物-生物制造CXO"
                />
              </div>
              <p>生命科学研究设备及原料</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus" />
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from "@/services/api.index";
import bread from "@/components/bread";
export default {
  components: {
    bread,
  },
  data() {
    return {
      currentType: -1,
      gene2: [
        { name: "修饰合成", img: "1", ref: "/equipment/Modified_synthesis" },
        { name: "仪器设备", img: "2", ref: "/equipment/Instruments_equipment" },
        { name: "化学试剂", img: "4", ref: "/equipment/Chemical_Reagents" },
        { name: "生物试剂", img: "/fenzi1_3", ref: "/molecular-reagent" },
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: "",
    };
  },
  created() {
    this.getResourceColumns();
  },
  methods: {
    // 资源栏目
    getResourceColumns() {
      resourceColumns().then((res) => {
        this.menuLists = res.data;
        this.total = this.baseMethods.getTotal(res);
        this.getResourcesLists(res.data[0].id);
      });
    },
    // 根据栏目id获取资源列表
    getResourcesLists(id) {
      this.categoryId = id;
      resourceDownloads(1, this.page, 20).then((res) => {
        this.resourcesLists = res.data;
        this.total = this.baseMethods.getTotal(res);
      });
    },
    // 下载
    bindDownLoad(imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name);
    },
    downFile(item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name);
    },
    // 翻页
    changePage(value) {
      this.page = value - 1;
      this.getResourcesLists(this.categoryId);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/equipment/life_sciences.vue